<template>
	<footer class="container-fluid">
		<div class="row">
			<div class="col-12">
				<p>&copy; Yard Online 2019</p>
			</div>
		</div>
	</footer>
</template>

<script>
export default {

}
</script>

<style lang="scss">
	@import "../scss/variables.scss";
	@import "../scss/mixins.scss";

	footer {
		background-color: $brand-color;
		p {
			padding-left: 20px;
			color: white;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue